import { createSlice } from "@reduxjs/toolkit";
import { adtypeFilterItems } from "src/utils/constants/filters";

const initialState = {
  city: null,
  districts: [],
  towns: [],
  localities: [],
  freetext: null,
  rangeselectitems: [],
  multiselectitems: [],
  singleselectitems: [],
  adtypesitems: [],
  companies: [],
};

export const filter = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setInitialLocation: (state, action) => {
      state.city = action.payload?.city;
      state.districts = action.payload?.districts;
      state.towns = action.payload?.towns;
    },
    setCity: (state, action) => {
      state.city = action.payload;
    },
    setDistricts: (state, action) => {
      state.districts = action.payload;
    },
    setTowns: (state, action) => {
      state.towns = action.payload;
    },
    setLocalities: (state, action) => {
      state.localities = action.payload || [];
    },
    setFreeText: (state, action) => {
      state.freetext = action.payload;
    },
    setInitialParams: (state, action) => {
      action.payload?.forEach((param) => {
        if (param.value.min !== undefined || param.value.max !== undefined) {
          state.rangeselectitems.push(param);
        } else if (Array.isArray(param.value)) {
          state.multiselectitems.push(param);
        } else if (adtypeFilterItems.includes(param.key)) {
          state.adtypesitems.push(param);
        } else if (typeof param.value === "object") {
          state.singleselectitems.push(param);
        }
      });
    },
    setMultiSelectParams: (state, action) => {
      state.multiselectitems = action.payload;
    },
    setAdTypesParams: (state, action) => {
      state.adtypesitems = action.payload;
    },
    setSingleSelectParams: (state, action) => {
      state.singleselectitems = action.payload;
    },
    setRangeSelectParams: (state, action) => {
      state.rangeselectitems = action.payload;
    },
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
  },
});

export const {
  setInitialLocation,
  setFreeText,
  setCity,
  setDistricts,
  setTowns,
  setLocalities,
  setInitialParams,
  setMultiSelectParams,
  setAdTypesParams,
  setSingleSelectParams,
  setRangeSelectParams,
  setCompanies,
} = filter.actions;

export default filter.reducer;
